import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from '@shared/components/icon';
import { NotificationComponent } from './components';

@NgModule({
  exports: [NotificationComponent],
  imports: [CommonModule, IconModule, NotificationComponent],
})
export class NotificationModule {}
